import { MouseEventHandler } from "react";
import { Button, Typography } from "@bca/ui-library";

const CloseButton: React.FunctionComponent<{
  onClick: MouseEventHandler<HTMLButtonElement>;
}> = ({ onClick }) => {
  return (
    <Button
      onClick={onClick}
      variant="tertiary"
      m={0}
      p={0}
      height={16}
      css={`
        position: absolute;
        top: 34px;
        right: 20px;
      `}
    >
      <Typography
        m={0}
        p={0}
        color="black"
        css={`
          font-size: 30px;
          font-weight: 100;
          line-height: 16px;
        `}
      >
        &times;
      </Typography>
    </Button>
  );
};

export default CloseButton;
